<template>
  <v-speed-dial
    v-model="fab"
    bottom
    :right="left ? false : true"
    :left="left"
    direction="top"
    transition="scale-transition"
  >
    <template v-slot:activator>
      <v-btn
        v-model="fab"
        color="blue darken-2"
        dark
        fab
      >
        <v-icon>group_work</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
    </template>

    <v-btn
      v-for="button in buttons"
      :key="button.icon"
      fab
      dark
      small
      :color="button.color"
      @click="button.action"
    >
      <v-icon>{{ button.icon }}</v-icon>
    </v-btn>
  </v-speed-dial>
</template>

<script>
export default {
  props: {
    buttons: {
      required: true,
      type: Array
    },
    left: {
      required: false,
      type: Boolean
    }
  },
  data(){
    return {
      fab: false
    }
  }
};
</script>

<style>
</style>
